
<div class="d-flex syrenis-grey nav-container">
  <v-navigation-drawer
    permanent
    width="260"
    class="navigation-drawer"
  >
    <!-- Logo - switches based on theme -->
    <img
      :src="currentLogo"
      class="ma-4 nav-full-logo"
      alt="Syrenis Logo"
    >

    <v-list
      nav
      dense
    >
      <!-- Note: Original uses {{ link.text | useLabels }} for i18n.
           This component library version displays raw text.
           Implement a custom filter or prop transform if localisation is needed. -->
      <template v-for="link in links">
        <!-- Simple link without sublinks -->
        <v-list-item
          v-if="!link.sublinks || link.sublinks.length === 0"
          :key="link.text"
          :to="link.customAction ? undefined : link.route"
          :link="!link.customAction"
          @click="triggerCustomAction(link.customAction)"
        >
          <v-list-item-title class="syrenis-black--text">
            <lucide-icon
              :name="mapIcon(link.icon)"
              :size="18"
              class="nav-icon-color--text mr-3"
              aria-hidden="true"
            />
            <span class="nav-text-with-chip">
              <span>{{ link.text }}</span>
              <v-chip
                v-if="link.chipLabel"
                class="nav-chip"
                color="steel-blue"
                x-small
              >
                {{ link.chipLabel }}
              </v-chip>
            </span>
          </v-list-item-title>
        </v-list-item>

        <!-- Link with sublinks -->
        <v-list-group
          v-else
          ref="mainListGroups"
          :key="link.text"
          link
          :ripple="false"
        >
          <v-list-item-content
            slot="activator"
            color="syrenis-black"
          >
            <v-list-item-title class="syrenis-black--text">
              <lucide-icon
                :name="mapIcon(link.icon)"
                :size="18"
                class="nav-icon-color--text mr-3"
                aria-hidden="true"
              />
              <span class="nav-text-with-chip">
                <span>{{ link.text }}</span>
                <v-chip
                  v-if="link.chipLabel"
                  class="nav-chip"
                  color="steel-blue"
                  x-small
                >
                  {{ link.chipLabel }}
                </v-chip>
              </span>
            </v-list-item-title>
          </v-list-item-content>

              <!-- Sublinks -->
              <template v-for="sublink in link.sublinks">
                <!-- Simple sublink without deeper sublinks -->
                <v-list-item
                  v-if="!sublink.deeperSublinks || sublink.deeperSublinks.length === 0"
                  :key="sublink.text"
                  :to="sublink.customAction ? undefined : sublink.route"
                  :link="!sublink.customAction"
                  @click="triggerCustomAction(sublink.customAction)"
                >
                  <v-list-item-title class="syrenis-black--text">
                    <span class="nav-text-with-chip">
                      <span>{{ sublink.text }}</span>
                      <v-chip
                        v-if="sublink.chipLabel"
                        class="nav-chip"
                        color="steel-blue"
                        x-small
                      >
                        {{ sublink.chipLabel }}
                      </v-chip>
                    </span>
                  </v-list-item-title>
                </v-list-item>

                <!-- Sublink with deeper sublinks -->
                <v-list-group
                  v-else
                  ref="subListGroups"
                  :key="sublink.text"
                  sub-group
                  class="syrenis-nav-sub-group"
                  :ripple="false"
                >
                  <v-list-item-content
                    slot="activator"
                    color="indigo"
                  >
                    <v-list-item-title class="syrenis-black--text">
                      <span class="nav-text-with-chip">
                        <span>{{ sublink.text }}</span>
                        <v-chip
                          v-if="sublink.chipLabel"
                          class="nav-chip"
                          color="steel-blue"
                          x-small
                        >
                          {{ sublink.chipLabel }}
                        </v-chip>
                      </span>
                    </v-list-item-title>
                  </v-list-item-content>

                  <!-- Deeper sublinks -->
                  <v-list-item
                    v-for="deeperSublink in sublink.deeperSublinks"
                    :key="deeperSublink.text"
                    :to="deeperSublink.customAction ? undefined : deeperSublink.route"
                    :link="!deeperSublink.customAction"
                    @click="triggerCustomAction(deeperSublink.customAction)"
                  >
                    <v-list-item-title class="syrenis-black--text">
                      <span class="nav-text-with-chip">
                        <span>{{ deeperSublink.text }}</span>
                        <v-chip
                          v-if="deeperSublink.chipLabel"
                          class="nav-chip"
                          color="steel-blue"
                          x-small
                        >
                          {{ deeperSublink.chipLabel }}
                        </v-chip>
                      </span>
                    </v-list-item-title>
                  </v-list-item>
                </v-list-group>
              </template>
        </v-list-group>
      </template>
    </v-list>
  </v-navigation-drawer>
</div>
